<template>
	<div class="cms-content">
		<div class="segmented-control-wrapper">
			<div class="container-title">
				<h2 class="heading-2">{{ $t('simulationTemplate') }}</h2>
				<ja-button
					v-if="showCreate"
					name="save"
					class="small"
					@click.native.prevent="onCreateNew"
					>{{ $t('createNew') }}</ja-button
				>
			</div>
			<!-- Table simulation Template -->
			<ja-simulation-template-table
				v-if="showCreate && dataTableSimulationTemplates"
				:data="dataTableSimulationTemplates"
				@editRow="handleEditRow"
				@deleteRow="handleDeleteRow"
			></ja-simulation-template-table>
			<!-- Create new Template -->
			<ja-create-new-simulation-template
				v-if="!showCreate"
				:data-edit="dataEdit"
				@saveSimulationTemplate="handleSaveSimulation"
				@cancel="handleCancel"
			></ja-create-new-simulation-template>
		</div>
	</div>
</template>
<script>
import Button from '@/components/ui/Button';
import SimulationTemplateTable from './SimulationTemplateTable.vue';
import CreateNewSimulationTemplate from './CreateNewSimulationTemplate.vue';
import SimulationTemplatesService from '@/services/cms/SimulationTemplatesService';
import AdminFacility from '@/mixins/AdminFacility';

export default {
	components: {
		jaSimulationTemplateTable: SimulationTemplateTable,
		jaCreateNewSimulationTemplate: CreateNewSimulationTemplate,
		jaButton: Button
	},
	mixins: [AdminFacility],
	props: {},
	data() {
		return {
			showCreate: true,
			dataTableSimulationTemplates: null,
			dataEdit: null
		};
	},
	computed: {
		isReturnOption() {
			return this.$store.state.isReturnOption;
		}
	},
	watch: {
		selectedFacility() {
			this.$store.commit('setLoading', true);
			this.showCreate = true;
			this.getSimulationTemplate();
		},
		isReturnOption(newValue) {
			if (newValue === true) {
				this.showCreate = true;
			} else {
				this.showCreate = false;
			}
		}
	},
	mounted() {
		if (this.selectedFacilityId != null) {
			this.$store.commit('setLoading', true);
			this.getSimulationTemplate();
		}
	},
	methods: {
		async getSimulationTemplate() {
			const data = await SimulationTemplatesService.getAll(
				this.selectedFacilityId
			);
			this.dataTableSimulationTemplates = data.sort((a, b) =>
				a.templateName < b.templateName ? -1 : 1
			);
			this.$store.commit('setLoading', false);
		},
		async onCreateNew() {
			const facilityId = this.selectedFacilityId;
			const data = await SimulationTemplatesService.getById(null, facilityId);
			this.dataEdit = data;
			this.showCreate = false;
			this.$store.commit('setIsReturnOption', false);
		},
		async handleEditRow(rowData) {
			const facilityId = this.selectedFacilityId;
			const data = await SimulationTemplatesService.getById(
				rowData.upperSimulationTemplate_ID,
				facilityId
			);
			this.dataEdit = data;
			this.showCreate = false;
			this.$store.commit('setIsReturnOption', false);
		},
		async handleSaveSimulation(template) {
			this.$store.commit('setLoading', true);
			await SimulationTemplatesService.update(template);
			await this.getSimulationTemplate();
			this.showCreate = true;
		},
		async handleDeleteRow(rowData) {
			this.$store.commit('setLoading', true);
			await SimulationTemplatesService.deleteById(
				rowData.upperSimulationTemplate_ID
			);
			await this.getSimulationTemplate();
			this.showCreate = true;
		},
		async handleCancel() {
			this.$store.commit('setLoading', true);
			await this.getSimulationTemplate();
			this.showCreate = true;
		}
	}
};
</script>
<style lang="scss" scoped>
.container-title {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.cms-content {
	margin: auto;
	max-width: 1000px;
	margin-top: 32px;
	margin-bottom: 32px;
}
</style>
